import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'zainergy-master',
  templateUrl: './master.component.html',
  styleUrls: ['./master.component.scss']
})
export class MasterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
